import { createSelector } from 'reselect';

export const selectMenus = (state) => state.menu.menus || [];

export const selectMultipleMenus = (state) => state.menu.menus.length > 1;

export const selectActiveCategoryId = (state) => state.menu.activeCategoryId;

export const selectIsCategoryAutoUpdateDisabled = (state) => state.menu.isAutoUpdateDisabled;

export const selectIsMenuAutoUpdateDisabled = (state) => state.menu.isAutoUpdateDisabled;

export const selectScrollToCategoryId = (state) => state.menu.scrollToCategoryId;

export const selectScrollToCategoryIndex = createSelector(
    selectScrollToCategoryId,
    selectMenus,
    (scrollToCategoryId, menus) => {
        if (!scrollToCategoryId) {
            return null;
        }

        const categoriesIds = menus.flatMap((menu) => (
            menu.categories.flatMap((category) => (
                category.positions.length > 0 && [
                    category.id,
                    category.positions.flatMap(() => null)
                ].flat()))));

        return categoriesIds.findIndex((id) => id === scrollToCategoryId);
    }
);

export const selectActiveMenuId = createSelector(
    selectActiveCategoryId,
    selectMenus,
    (activeCategoryId, menus) => {
        const categories = menus.flatMap((menu) => (
            menu.categories.flatMap((category) => ({
                categoryId: category.id,
                menuId: menu.id
            }
            ))));

        const activeCategory = categories.find((category) => category.categoryId === activeCategoryId);

        if (!activeCategory) {
            return null;
        }

        return activeCategory.menuId;
    }
);

export const selectCategories = createSelector(
    selectMenus,
    selectActiveMenuId,
    selectActiveCategoryId,
    (menus, activeMenuId, activeCategoryId) => {
        if (menus && activeMenuId) {
            return menus.find((menu) => menu.id === activeMenuId).categories.map(({ id, name }) => ({
                id,
                name,
                isActive: id === activeCategoryId
            }));
        }

        return [];
    }
);

export const selectFlatMenu = createSelector(
    selectMenus,
    (menus) => menus.flatMap((menu) => (
        menu.categories.flatMap((category) => {
            if (category.positions.length) {
                return [{
                    id: category.id,
                    category,
                    menuId: menu.id,
                    menuName: menu.name,
                    type: 'category'
                }, ...category.positions.map((position) => ({
                    ...position,
                    category: category.name,
                    menuId: menu.id,
                    menuName: menu.name,
                    categoryId: category.id,
                    type: 'position'
                }))
                ].flat();
            }

            return [];
        })
    ))
);
